import ActionTypes from '../actionTypes'

const initialState = {
  vehicles: [],
  vehicleModelWithStatusCount: 0,
  oemList: [],
  oemSubscribedVehicles: [],
  oemSubscribedVehiclesCount: 0,
}

const getFleetReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.FLEET.OEM_API:
      return {
        ...state,
        vehicles: payload?.vehicleModelWithStatus,
        vehicleModelWithStatusCount: payload?.totalCount
      };
    case ActionTypes.FLEET.OEM_LIST:
      return {
        ...state,
        oemList: payload
      };
    case ActionTypes.FLEET.OEM_SUBSCRIBED_VEHICLES:
      return {
        ...state,
        oemSubscribedVehicles: payload?.vehicles || [],
        oemSubscribedVehiclesCount: payload?.totalCount || 0
      };
    default:
      return state;
  }
};

export default getFleetReducer;
